// Reactive page-header store. Pages rufen setPageHeader(title,
// subtitle) im $effect, App.svelte's Top-Header rendert daraus.
// Tim 2026-04-29: "Der obere Teil nimmt viel Raum von der
// Arbeitsfläche ein. Kann wie hier Sicherheit (DB) der Header
// weiter nach oben wandern, wo jetzt /security steht wander?"
//
// Lifecycle:
//   - App.svelte resettet den Header bei jedem Route-Wechsel auf
//     den route.label-Default. Pages mit eigenem Header setzen
//     danach via setPageHeader im $effect.
//   - Pages ohne setPageHeader-Aufruf zeigen einfach das route.label
//     im Header (passt für die meisten Sektionen).

import { SvelteMap } from "svelte/reactivity";

const _state = new SvelteMap<string, string>([
  ["title", ""],
  ["subtitle", ""],
]);

export function setPageHeader(title: string, subtitle?: string): void {
  _state.set("title", title);
  _state.set("subtitle", subtitle ?? "");
}

export function getPageTitle(): string {
  return _state.get("title") ?? "";
}

export function getPageSubtitle(): string {
  return _state.get("subtitle") ?? "";
}
